export default __webpack_public_path__ + "static/media/grid_black_icon.e3f15168.svg";